var _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M26.5 13.8l7.5 7.5-7.5 7.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M34 21.3h-7.8s-4.3.3-7.6-3.7c-4.1-5.4-8.3-5-8.3-5H3.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M33.9 21.3h-7.8s-4.3-.3-7.6 3.7c-4.1 5.4-8.3 5-8.3 5H3.1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 39.4,
    cy: 21.3,
    r: 1.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M26.5 13.8l7.5 7.5-7.5 7.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTo);
export default __webpack_public_path__ + "static/media/addTo.688982d90991a9b7f8c959c58746ae1c.svg";
export { ForwardRef as ReactComponent };